﻿import './tracker.config';

import TKModuleFactory from '@tk/utilities/tk.module.factory';
import TKManager from '@tk/basics/tk.manager';
import TKViewport from '@tk/basics/tk.viewport';
import TKNavigationSidebar from '@tk/components/tk.navigation.sidebar';
import TKHeader from '@tk/components/tk.header';
import TKBasketButton from '@/components/tk.basket.button';
import TKCarousel from '@/components/kdmz.carousel';
import TKContextMenu from '@/components/kdmz.context.menu';
import TKFlag from '@tk/components/tk.flag';
import TKProductTile from '@tk/components/tk.product.tile';
import TKProductVariants from '@tk/components/tk.product.variants';
// import TKTooltip from '@tk/components/tk.tooltip';
import TKPrice from '@tk/components/tk.price';
import TKStock from '@tk/components/tk.stock';
import TKStaticContent from '@tk/controls/tk.static.content';
import TKArticleList from '@tk/components/tk.article.list';
import TKFavoriteButton from '@tk/components/tk.favorite.button';
import TKFormValidator from '@/controls/kdmz.form.validator';
import TKAssetGallery from '@tk/components/tk.asset.gallery';
import TKSelection from '@tk/controls/tk.selection';
import TKArtSpecTable from '@tk/components/tk.art.spec.table';
import TKCompareButton from '@tk/components/tk.compare.button';
import TKShowMore from '@tk/components/tk.show.more';
import TKSelectRedirect from '@tk/controls/tk.select.redirect';
import TKPopup from '@tk/components/tk.popup';
import TKArticleListSort from '@tk/components/tk.article.list.sort';
import TKArticleListLayoutSwitch from '@tk/components/tk.article.list.layout.switch';
import TKBreadcrumb from '@tk/components/tk.breadcrumb';
import TKCompareListLink from '@tk/components/tk.compare.list.link';
import TKTable from '@tk/components/tk.table';
import TKQuickOrder from '@/components/kdmz.quick.order';
import KDMZFreitext from '@/components/kdmz.freitext';
import TKTabsTab from '@/components/kdmz.tabs.tab';
import TKFavoriteInfo from '@/components/tk.favorite.info';
import TKTabsAccordion from '@/components/kdmz.tabs.accordion';
import TKButtonDropdown from '@/controls/kdmz.button.dropdown';
import KDMZSearch from '@/components/kdmz.search';
import TKHeaderSearch from '@/components/tk.header.search';
import TKTracker from '@tk/components/tracker/tk.tracker';
// import TKFormTracker from '@tk/components/tk.form.tracker';
import TKTracking from '@tk/components/tracker/tk.tracking';

// Custom KDMZ elements
import KDMZFormElement from '@/components/kdmz.form.element';
import KDMZDialog from '@/components/kdmz.dialog';
import KDMZMinibasket from '@/components/kdmz.minibasket';
import KDMZBasketButton from '@/components/kdmz.basket.button';
import KDMZWeb2print from '@/components/kdmz.web2print';
import KDMZAsyncPostField from '@/components/kdmz.async.post.field';
import KDMZFileUploadArea from '@/controls/kdmz.file.upload.area';

import 'tippy.js/dist/tippy.css';
import '@splidejs/splide/dist/css/splide.min.css';
import '@scss/modules/general.scss';
import '@scss/modules/article.scss';
import '@iconfont/iconfont/material-icons.css';
import '@scss/modules/printorder.scss';

export default class Article extends TKModuleFactory {
    constructor() {
        super([
            { name: 'tk-manager', constructor: TKManager },
            { name: 'tk-viewport', constructor: TKViewport },
            { name: 'tk-nav-sidebar', constructor: TKNavigationSidebar },
            { name: 'tk-header', constructor: TKHeader },
            { name: 'tk-basket-button', constructor: TKBasketButton },
            { name: 'tk-carousel', constructor: TKCarousel },
            { name: 'tk-context-menu', constructor: TKContextMenu },
            { name: 'tk-flag', constructor: TKFlag },
            { name: 'tk-product-tile', constructor: TKProductTile },
            { name: 'tk-product-variants', constructor: TKProductVariants },
            // { name: 'tk-tooltip', constructor: TKTooltip },
            // ab hier
            { name: 'tk-price', constructor: TKPrice },
            { name: 'tk-stock', constructor: TKStock },
            { name: 'tk-static-content', constructor: TKStaticContent },
            { name: 'tk-tabs-tab', constructor: TKTabsTab },
            { name: 'tk-article-list', constructor: TKArticleList },
            { name: 'tk-favorite-button', constructor: TKFavoriteButton },
            { name: 'tk-favorite-info', constructor: TKFavoriteInfo },
            { name: 'tk-form-validator', constructor: TKFormValidator },
            { name: 'tk-asset-gallery', constructor: TKAssetGallery },
            { name: 'tk-tabs-accordion', constructor: TKTabsAccordion },
            { name: 'tk-selection', constructor: TKSelection },
            { name: 'tk-art-spec-table', constructor: TKArtSpecTable },
            { name: 'tk-compare-button', constructor: TKCompareButton },
            { name: 'tk-show-more', constructor: TKShowMore },
            { name: 'tk-tracker', constructor: TKTracker },
            { name: 'tk-tracking', constructor: TKTracking },
            // bis hier
            { name: 'tk-select-redirect', constructor: TKSelectRedirect },
            { name: 'tk-popup', constructor: TKPopup },
            { name: 'tk-article-list-sort', constructor: TKArticleListSort },
            { name: 'tk-article-list-layout-switch', constructor: TKArticleListLayoutSwitch },
            { name: 'tk-breadcrumb', constructor: TKBreadcrumb },
            { name: 'tk-compare-list-link', constructor: TKCompareListLink },
            { name: 'tk-button-dropdown', constructor: TKButtonDropdown },
            { name: 'tk-header-search', constructor: TKHeaderSearch },
            { name: 'kdmz-search', constructor: KDMZSearch },

            { name: 'tk-form-element', constructor: KDMZFormElement },
            { name: 'tk-dialog', constructor: KDMZDialog },
            { name: 'tk-minibasket', constructor: KDMZMinibasket },
            { name: 'tk-table', constructor: TKTable },
            { name: 'tk-quick-order', constructor: TKQuickOrder },
            { name: 'kdmz-basket-button', constructor: KDMZBasketButton },
            { name: 'kdmz-web2print', constructor: KDMZWeb2print },
            { name: 'kdmz-freitext', constructor: KDMZFreitext },
            { name: 'kdmz-async-post-field', constructor: KDMZAsyncPostField },
            { name: 'kdmz-file-upload-area', constructor: KDMZFileUploadArea },
        ]);
    }
}

new Article();
